export default __webpack_public_path__ + "static/media/template-1.10663da9.png";